import styled, { css } from "styled-components";

const InfoContainer = styled.div`
    border: ${props => props.theme.lightGrayBorder};
    border-radius: 0.5rem;
    padding: 1.6rem;
    background: ${props => props.theme.lightGray3};
    margin-bottom: 1.6rem;
    position: relative;

	@media only screen and (min-width: ${props => props.theme.desktopSmall}) {
		padding: 2rem;
	}

    .icon.thumbs-up {
        margin-right: 3rem;
        margin-top: 0.5rem;
        @media only screen and (min-width: ${props => props.theme.desktopSmall}) {
            width: 4rem;
            height: 4rem;
        }
    }

    .password-success {
        padding-top: 1.5rem;
        margin-right: 2rem;
    }

	${props => {
        return (
            props.section !== "marketing" &&
            css`
                h6, .h6 {
					font-size: 1.4rem;
					margin-bottom: 0;
					color: ${props => props.theme.darkGreen};
    			}
            `
        );
    }}

	${props => {
		return (
			props.section == "marketing" &&
			css`
				@media only screen and (max-width: ${props.theme.upToTablet}) {
					h6, .h6 {
						font-size: 1.8rem;
					}
					h5, .h5 {
						font-size: 2rem;
					}
				}
			
			`
		);
	}}
   
    p {
        font-size: 1.4rem;
        padding-right: 3rem;

		&:last-of-type {
			margin-bottom: 0;
		}
    }
    .profile {
        &__note {
            font-size: 1.2rem;
            margin-bottom: 0;
            color: ${props => props.theme.lightGray4};
        }
        &__name {
            margin-bottom: 0;
        }
    }
    h4, .h4 {
        color: ${props => props.theme.darkGreen};
        @media only screen and (min-width: ${props => props.theme.desktopSmall}) {
            font-size: 2.4rem;
        }
    }
    .infoContainer__edit {
        color: ${props => props.theme.lightGreen};
        font-family: ${props => props.theme.fontBold};
        position: absolute;
        right: 2rem;
        font-size: 1.4rem;
        bottom: 2rem;
        text-decoration: none;
        border: ${props => props.theme.lightGrayBorder};
        border-radius: 0.3rem;
        padding: 1rem 1rem 0.5rem 0.5rem;
        height: 4rem;
        @media only screen and (min-width: ${props => props.theme.desktopSmall}) {
            top: 3rem;
            padding: 0;
            border: none;
            height: 2rem;
        }
        svg {
            margin-left: 1rem;
        }
        .edit__text {
            padding-bottom: 2rem;
            position: absolute;
            left: -3rem;
            top: -0.2rem;
            display: none;
            @media only screen and (min-width: ${props => props.theme.desktopSmall}) {
                display: block;
            }
        }
    }

    .deliveryAddress {
        margin: 0.5rem 0;
        position: relative;
        padding-left: 2.5rem;
        &:before {
            content: "";
            width: 1.5rem;
            height: auto;
            background-position: bottom 0.3rem right;
            position: absolute;
            left: 0rem;
            top: 0.1rem;
            bottom: 0.7rem;
            background-image: url("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTJweCIgaGVpZ2h0PSI5cHgiIHZpZXdCb3g9IjAgMCAxMiA5IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IFNrZXRjaCA1OS4xICg4NjE0NCkgLSBodHRwczovL3NrZXRjaC5jb20gLS0+CiAgICA8dGl0bGU+R2xvYmFsL0F0b21zL0ljb25zL1RpY2sgZ3JlZW48L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZyBpZD0iU3ltYm9scyIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIj4KICAgICAgICA8ZyBpZD0iU2Vjb25kYXJ5LXRleHQvbGVmdCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMC4wMDAwMDAsIC03LjAwMDAwMCkiIHN0cm9rZT0iIzAwQTc2QSIgc3Ryb2tlLXdpZHRoPSIyIj4KICAgICAgICAgICAgPGcgaWQ9Ikdsb2JhbC9BdG9tcy9JY29ucy9UaWNrLWdyZWVuIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjAwMDAwMCwgOC4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxsaW5lIHgxPSIxLjExMTYyNzgzIiB5MT0iMy4wNzk1MTI4MyIgeDI9IjQuMDk3NzQxOTQiIHkyPSI2LjIxNDkzMjY0IiBpZD0iU3Ryb2tlLTIzIj48L2xpbmU+CiAgICAgICAgICAgICAgICA8bGluZSB4MT0iMTAuMjI4NjcxNyIgeTE9IjAiIHgyPSI0LjIxMDUwNzE5IiB5Mj0iNi4yODI2NTAzNyIgaWQ9IlN0cm9rZS0yNSI+PC9saW5lPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=");
            background-size: 1.4rem;
            background-repeat: no-repeat;
        }
    }
    ${props => {
        return (
            props.secondary &&
            css`
                border: ${props.theme.darkBlueBorder};
                padding: 2rem 3rem;
            `
        );
    }}

    ${props => {
        return (
            props.shiny &&
            css`
                box-shadow: ${props.theme.grayBoxShadow};
            `
        );
    }}

	.m53__container {
		margin-bottom: 0;
	}
`;

const InfoContainerLocked = styled.button`
    position: absolute;
    width: 2.5rem;
    height: 3rem;
    top: 2rem;
    right: 2rem;
    cursor: not-allowed;
    &:before {
        content: "";
        width: 3.5rem;
        height: 3rem;
        background-position: right bottom 0.3rem;
        position: absolute;
        right: 0;
        top: 0.1rem;
        bottom: 0.7rem;
        background-image: url("data:image/svg+xml;base64,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");
        background-repeat: no-repeat;
    }
`;

const FlexContainer = styled.div`
    display: flex;
    ${props => {
        return (
            props.end &&
            css`
                justify-content: flex-end;
            `
        );
    }}
    ${props => {
        return (
            props.spacearound &&
            css`
                justify-content: space-around;
                h4 {
                    margin-bottom: 1rem;
                }
            `
        );
    }}
`;

const SideContainer = styled.div`
    width: 100%;
    @media only screen and (min-width: 768px) {
        max-width: calc(50% - 2rem);
    }
`;

export { InfoContainer, FlexContainer, SideContainer, InfoContainerLocked };
